import { httpClient } from '@/shared/services/httpClient';

const baseUrl = '/ui-assets/access/configurations';

export const LocaleService = {
  get: async (localeUrl: string): Promise<any> => httpClient.client
    .get(`${baseUrl}${localeUrl}`)
    .then(res => res.data),
};

export default LocaleService;
